<template>
  <div @dblclick="handleDoubleClick">
    <textarea ref="sqlEditor" :placeholder="$t('Home.pleaseEnter')" class="sql-editor" v-model="SQLvalue"></textarea>
    <el-button v-if="isFormattingSQL" type="primary" size="mini" style="margin:10px 0 0 0" @click="formatSQL">格式化 SQL</el-button>
  </div>
</template>

<script>
// 引入 CodeMirror 样式和模块
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/dracula.css';  // 可选的主题
import 'codemirror/mode/sql/sql.js';    // SQL 模式
import 'codemirror/addon/hint/show-hint.css';  // 提示样式
import 'codemirror/addon/hint/sql-hint.js';    // SQL 提示功能
import CodeMirror from 'codemirror';
import sqlFormatter from 'sql-formatter';  // 引入 sql-formatter 库

export default {
  name: 'SqlEditor',
  data() {
    return {
      editor: null,
      SQLvalue: this.value || '',  // 初始值
    };
  },
  props: {
    value: { type: String, default: '' },
    readOnly: { type: [Boolean, String], default: false },  // 默认为 false
    editorHeight: { type: [String, Number], default: '100px' },  // 高度可以动态调整
    isFormattingSQL: { type: Boolean, default: false }
  },
  watch: {
    value(newVal) {
      if (this.editor && this.editor.getValue() !== newVal) {
        this.SQLvalue = newVal;
        this.editor.setValue(newVal);  // 保证 CodeMirror 内容更新
      }
    },
    SQLvalue(newValue) {
      // 只有在编辑器内容和 model 值不同的情况下才更新编辑器内容
      if (this.editor && this.editor.getValue() !== newValue) {
        this.editor.setValue(newValue);
      }
    },
    // 监听 readOnly 的变化，动态更新 CodeMirror 编辑器的只读状态
    readOnly(newValue) {
      if (this.editor) {
        this.editor.setOption('readOnly', newValue);  // 动态更新只读状态
      }
    }
  },
  mounted() {
    // 设置 CodeMirror 编辑器配置
    const editorOptions = {
      mode: 'text/x-sql',    // 使用 SQL 模式
      theme: 'dracula',      // 使用 Dracula 主题
      lineNumbers: true,     // 显示行号
      matchBrackets: true,   // 括号匹配
      indentUnit: 2,         // 设置缩进单位
      readOnly: this.readOnly,  // 根据 readOnly 属性传参来控制是否禁用编辑
    };

    // 初始化 CodeMirror 编辑器
    this.editor = CodeMirror.fromTextArea(this.$refs.sqlEditor, editorOptions);

    // 设置编辑器高度
    this.editor.setSize(null, this.editorHeight);  // 设置 CodeMirror 编辑器的高度
    // 绑定输入事件
    this.editor.on('change', this.handleEditorChange, { passive: false });
  },
  beforeDestroy() {
    // 组件销毁前销毁编辑器
    if (this.editor) {
      this.editor.toTextArea();
    }
  },
  methods: {
    handleDoubleClick() {
      this.$emit('dblclick', this.SQLvalue);
    },
    handleEditorChange() {
      // 获取编辑器的内容
      this.SQLvalue = this.editor.getValue();
      this.$emit("input", this.SQLvalue)
    },
    // 格式化 SQL 内容
    formatSQL() {
      const rawSQL = this.editor.getValue();  // 获取编辑器的原始 SQL 内容
      const formattedSQL = sqlFormatter.format(rawSQL);  // 使用 sql-formatter 进行格式化
      this.editor.setValue(formattedSQL);  // 设置格式化后的内容到编辑器
    }
  }
};
</script>

<style scoped lang="scss">
textarea[placeholder] {
  color: white; /* 设置提示文本的颜色 */
}
.sql-editor {
  width: 100%;  // 容器宽度
  height: 100%;
}
.editor-toolbar {
  margin-bottom: 10px;
}

/deep/ .CodeMirror-code {
  line-height: 20px;
}

.CodeMirror {
  height: 100%;
  /* 动态高度由 parent 控制 */
}
</style>
